import { userMessages } from "../Constants/messages";

export const getUserMessage = () => {
  return userMessages.shift();
};
export const addUserMessage = message => {
  return userMessages.unshift(message);
};



// WEBPACK FOOTER //
// ./src/Utils/userMessages.js